import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mailwithattachment',
  templateUrl: './mailwithattachment.component.html',
  styleUrls: ['./mailwithattachment.component.css']
})
export class MailwithattachmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  	
  }

}
